import React from 'react';
import * as RadixCollapsible from '@radix-ui/react-collapsible';

const ExtendedContent = ({ children, ...props }) => {
  const handleAnimationEnd = event => {
    if (
      event.animationName === 'slideDown' &&
      event.target.dataset.state === 'open'
    ) {
      event.currentTarget.style.overflow = 'visible';
    }
  };

  const handleAnimationStart = event => {
    if (
      event.animationName === 'slideUp' &&
      event.target.dataset.state === 'closed'
    ) {
      event.currentTarget.style.overflow = 'hidden';
    }
  };

  return (
    <RadixCollapsible.Content
      {...props}
      onAnimationEnd={handleAnimationEnd}
      onAnimationStart={handleAnimationStart}
    >
      {children}
    </RadixCollapsible.Content>
  );
};

const Collapsible = {
  Root: RadixCollapsible.Root,
  Trigger: RadixCollapsible.Trigger,
  Content: ExtendedContent,
};

export default Collapsible;
